import { useGlobalStore, useUserStore } from '@shared/store';
import { useHostEnv } from '@shared/hooks';
import { searchToJson } from '@shared/utils';

// 初始化 前端日志 埋点参数
export const initWebFunnyParams = async () => {
  try {
    const { appData, firstEntryStaffId = '' } = useGlobalStore();
    const { userInfo } = useUserStore();
    const { currentCorpId = '' } = appData;
    const { staffId = '', customerType = '', distinctId } = userInfo || {};
    const { currentHostEnv } = useHostEnv();

    const { agentId } = searchToJson();
    const webFunnyUserId = firstEntryStaffId || staffId || '';

    const params = {
      agentId,
      currentCorpId,
      userId: webFunnyUserId,
      staffId: firstEntryStaffId || staffId,
      userType: customerType,
      distinctId: distinctId,
      env: currentHostEnv,
    };

    // console.log('初始化 WebFunny 参数：', params);

    window.localStorage.wmUserInfo = JSON.stringify({
      userId: distinctId,
      userTag: `currentCorpId=${currentCorpId}|agentId=${agentId}|staffId=${webFunnyUserId}|userType=${customerType}|env=${currentHostEnv}`,
      projectVersion: '',
    });
  } catch (error) {
    console.log('初始化 WebFunny 参数错误：', error);
  }
};
